import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { ModalOverlay } from './ui';
import { WhatsAppHelp } from './WhatsAppHelp';

type InternModalProps = {
  weeksLeft: number;
  clinicId: string;
  onClose: () => void;
};

export function InternModal({ weeksLeft, clinicId, onClose }: InternModalProps) {
  const hasWeeks = weeksLeft > 0;

  return (
    <ModalOverlay onBackdropClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="intern-modal-title"
        className="app-dialog bg-white shadow-2xl w-full max-w-sm p-5 sm:p-6"
      >
        <div className="flex items-start justify-between mb-4">
          <h2 id="intern-modal-title" className="font-heading text-lg font-bold text-ink">
            Intern
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-ink-faint hover:text-ink p-1 rounded-lg hover:bg-gray-100"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <p className="text-sm text-ink mb-4">
          You have <span className="font-semibold text-teal tabular-nums">{weeksLeft}</span> week
          {weeksLeft === 1 ? '' : 's'} left.
        </p>

        <ol className="space-y-3 text-sm text-ink mb-5">
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-teal text-white text-xs font-semibold flex items-center justify-center shrink-0 mt-0.5">1</span>
            <span>Pick the branch.</span>
          </li>
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-teal text-white text-xs font-semibold flex items-center justify-center shrink-0 mt-0.5">2</span>
            <span>Tap a week, then the days and time you want.</span>
          </li>
          <li className="flex gap-3">
            <span className="w-6 h-6 rounded-full bg-teal text-white text-xs font-semibold flex items-center justify-center shrink-0 mt-0.5">3</span>
            <span>Press Confirm, wait a few seconds, then Confirm again.</span>
          </li>
        </ol>

        <p className="text-xs text-ink-soft mb-4">
          Each booking uses 1 week. You cannot undo it in the app.
        </p>

        <div className="mb-4">
          <WhatsAppHelp label="WhatsApp us for help" />
        </div>

        {hasWeeks ? (
          <Link
            to={`/student/clinics/${clinicId}/book`}
            onClick={onClose}
            className="w-full py-3.5 rounded-radius-sm bg-sand text-white font-semibold text-sm min-h-[48px] flex items-center justify-center"
          >
            Got it
          </Link>
        ) : (
          <Link
            to="/plans"
            onClick={onClose}
            className="w-full py-3.5 rounded-radius-sm bg-sand text-white font-semibold text-sm min-h-[48px] flex items-center justify-center"
          >
            Get a plan
          </Link>
        )}
      </div>
    </ModalOverlay>
  );
}
